<!-- begin: Header -->
<div ktHeader #ktHeader class="header" [ngClass]="headerClasses" id="kt_header">
  <!--begin::Container-->
  <div [ngClass]="headerContainerClasses" class="d-flex align-items-stretch justify-content-between">
    <ng-container *ngIf="(loader.progress$ | async) > 0">
      <ngb-progressbar class="loading-bar" [value]="loader.progress$ | async" height="3px"></ngb-progressbar>
    </ng-container>
    <kt-subheader></kt-subheader>
    <img *ngIf="policyImg && role === 'FINAL'" [src]="'data:image/jpeg;base64,' + policyImg" class="ml-auto mr-8 my-auto" style="max-height: 70%; border-radius: 0.42rem; overflow: hidden" />

    <!-- begin:: Header Topbar -->
    <!--begin::Topbar-->
    <kt-topbar class="topbar"></kt-topbar>
    <!--end::Topbar-->
    <!-- end:: Header Topbar -->
  </div>
  <!--end::Container-->
</div>
<!-- end: Header -->
